<div class="relative">
  <div class="border-gray-400 border  py-1 px-2 rounded-md bg-gray-100 text-center">{{title}}</div>
  <input type="file" class="cursor-pointer opacity-0 absolute inset-0" [formControl]="controlName" (change)="eventChooseImage.emit($event)" />
</div>